import { addLocalDays, localDayKey, weekRange } from '../../../../Utils/dates/localDay';
import { formatShortDate, formatTime } from '../../../../Utils/dates/formatDate';
import { formatKm } from '../../../../Utils/format/pace';

/**
 * Pure: API sessions -> the seven local days (Monday first) of the week containing `now`.
 * Completion counts show only for sessions on or before today.
 */
export const buildWeekPlan = (sessions, now) => {
    const { from } = weekRange(now);
    const todayKey = localDayKey(now);

    const days = Array.from({ length: 7 }, (_, i) => {
        const date = addLocalDays(from, i);
        const key = localDayKey(date);
        return { key, date, label: formatShortDate(date), isToday: key === todayKey, sessions: [] };
    });
    const byKey = new Map(days.map(d => [d.key, d]));

    [...(sessions || [])]
        .sort((a, b) => new Date(a.scheduledDate) - new Date(b.scheduledDate))
        .forEach(session => {
            const day = byKey.get(localDayKey(session.scheduledDate));
            if (!day) return;
            day.sessions.push({
                id: session.id,
                time: formatTime(session.scheduledDate),
                groupName: session.group?.name,
                title: session.program?.name,
                subtitle: session.program?.type,
                km: typeof session.volume === 'number' ? formatKm(session.volume) : null,
                status: session.status,
                completion:
                    day.key <= todayKey && session.athletes ? { ...session.athletes } : null
            });
        });
    return days;
};
